import './AuthTitle.scss';

function AuthTitle({ title }) {
    return (
        <div className='auth-title'>
            <h1>{title}</h1>
            <p>Fill in your credentials and click on the {title} button</p>
        </div>
        )
}
export default AuthTitle;